import { api } from './api';

const userCustomersGetList = async (params) => {
  const response = await api({
    url: `UserCustomers/GetList`,
    method: 'GET',
    id: 'UserCustomers-GetList',
    params,
    cache: {
      ttl: 1000 * 60 * 60 * 8,
    },
  });
  return response.data;
};

const customerLogosGetList = async (data) => {
  const response = await api({
    url: `CustomerLogos/getList`,
    method: 'GET',
    params: data,
  });
  return response.data;
};

const customerVouList = async (data) => {
  const response = await api({
    url: `CustomerVous/getList`,
    method: 'GET',
    params: data,
  });
  return response.data;
};

const customersServices = {
  userCustomersGetList,
  customerLogosGetList,
  customerVouList,
};

export default customersServices;
